module.exports = __webpack_public_path__ + "media/images/customer-locating-icon-19765421f4b94e45afdccdbc50545db4.png";